import z from "zod";
import { mapErrorsToFields } from "../../../../utils";
import CharityIssueService from "../../../../services/CharityIssueService";

const api = new CharityIssueService();
export type State = {
  errors?: {
    name?: string[];    
    general?: string[];
  };
  message?: string | null;
  success?: boolean;
  defaultValues?: {
    name?: string;    
  };
};
const FormSchema = z.object({
  name: z.string().min(1, "Name is required."),  
  charityIssueCategoryId: z.number(),

});

export async function addCharityIssue(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",    
    charityIssueCategoryId: parseInt(formData.get("charityIssueCategoryId")?.toString() ?? "0"),
  };
  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Create Charity Issue.",
      };
    }
    const { name, charityIssueCategoryId} = validatedFields.data;

    const result = await api.createCharityIssue({ name, charityIssueCategoryId});
    if (result.status == 201)
      return {
        message: "Charity issue created successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to create charity issue.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to create charity issue.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}
export async function updateCharityIssue(
    id: number,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",    
    charityIssueCategoryId: parseInt(formData.get("charityIssueCategoryId")?.toString() ?? "0"),
  };  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Update Charity Issue.",
      };
    }
    const { name, charityIssueCategoryId } = validatedFields.data;

    const result = await api.updateCharityIssue({ id, name, charityIssueCategoryId });
    if (result.status == 204)
      return {
        message: "Charity issue updated successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to update charity issue.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to update charity issue.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}

export async function deleteCharityIssue(id: number, prevState: State) {
  try {
    await api.deleteCharityIssue(id);
    return {
      message: "Charity issue deleted successfully.",
      success: true,
    };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to delete charity issue.",
      success: false,
    };
  }
}
